import { useState } from "react";

import { css } from "@compiled/react";

import { SandboxCursor } from "./assets/sandbox-cursor";
import { SandboxEyelash } from "./assets/sandbox-eyelash";

const sandboxBtn = css({
    position: "relative",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    background: "transparent",
    padding: "8px 28px",
    border: `2px solid #101214`,
    color: "#101214",
    borderRadius: "40px"
});

const eyelashContainer = css({
    position: "absolute",
    insetBlockStart: "0px",
    insetInlineStart: "34px",
    opacity: 0,
    transition: "300ms"
});
const eyelashContainerHover = css({
    opacity: 1
});
const cursorContainer = css({
    transition: "300ms",
    display: "flex"
});
const cursorContainerHover = css({
    transform: "rotate(15deg)"
});

const btnTextCss = css({
    margin: 0,
    transition: "300ms",
    paddingInlineStart: "7px"
});
const btnTextHoverCss = css({});

type SandboxButtonProps = {
    readonly url: string;
};

export const SandboxButton = ({ url }: SandboxButtonProps) => {
    const [btnHover, setBtnHover] = useState(false);
    const sandboxBtnText = "Show me";

    return (
        <a
            css={sandboxBtn}
            data-event-component="linkButton"
            data-event-container="heroSection"
            data-event="clicked"
            data-product-key="jira"
            data-label-english="Try a demo"
            data-label={sandboxBtnText}
            target={undefined}
            href={url}
            onMouseEnter={() => setBtnHover(true)}
            onMouseLeave={() => setBtnHover(false)}
        >
            <div css={[eyelashContainer, btnHover && eyelashContainerHover]}>
                <SandboxEyelash />
            </div>
            <div css={[cursorContainer, btnHover && cursorContainerHover]}>
                <SandboxCursor />
            </div>
            <p css={[btnTextCss, btnHover && btnTextHoverCss]}>
                {sandboxBtnText}
            </p>
        </a>
    );
};
